import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, LogIn, ArrowLeft } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/apiClient";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 page-cream">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to store
        </Link>
        <div className="card-soft rounded-3xl p-8 animate-fade-up">
          <div className="mb-8">
            <span className="font-display font-extrabold text-2xl tracking-tight">Ethos<span style={{ color: "var(--gold)" }}>.</span></span>
            <span className="block text-[9px] font-bold tracking-[0.3em] text-muted-foreground -mt-0.5">ADMIN · CARTBOUNTY</span>
          </div>
          <h1 className="font-display font-extrabold text-2xl mb-1">Admin Console</h1>
          <p className="text-sm text-muted-foreground mb-6">Abandoned cart monitoring & recovery analytics</p>

          <form onSubmit={submit} className="space-y-4">
            <div><Label className="text-xs text-muted-foreground">Email</Label><Input data-testid="admin-login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11 bg-white border-border" required /></div>
            <div><Label className="text-xs text-muted-foreground">Password</Label><Input data-testid="admin-login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11 bg-white border-border" required /></div>
            <button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="w-full h-11 rounded-xl btn-ink font-display font-bold flex items-center justify-center gap-2">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><LogIn className="w-4 h-4" /> Sign in</>}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
